import { render, staticRenderFns } from "./SalesLeads.vue?vue&type=template&id=5fea5e27&"
import script from "./SalesLeads.vue?vue&type=script&lang=js&"
export * from "./SalesLeads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports